import { fn } from "@ember/helper";
import ComposerTipCloseButton from "discourse/components/composer-tip-close-button";
import Topic from "discourse/components/search-menu/results/type/topic";
import { i18n } from "discourse-i18n";

const SimilarTopicsComposerMessage = <template>
  <ComposerTipCloseButton @action={{fn @closeMessage @message}} />
  <div class="composer-popup__content">

    <h3>{{i18n "composer.similar_topics"}}</h3>

    <ul class="topics">
      {{#each @message.similarTopics as |topic|}}
        <div class="similar-topic">
          <Topic @result={{topic}} @withTopicUrl={{true}} />
        </div>
      {{/each}}
    </ul>
  </div>
</template>;

export default SimilarTopicsComposerMessage;
